import { render, staticRenderFns } from "./ObjectNew.vue?vue&type=template&id=1afaf5fc&"
import script from "./ObjectNew.vue?vue&type=script&lang=js&"
export * from "./ObjectNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports